import { render, staticRenderFns } from "./SistemaGrupoControllerEdit.vue?vue&type=template&id=e625327a"
import script from "./SistemaGrupoControllerEdit.vue?vue&type=script&lang=js"
export * from "./SistemaGrupoControllerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports